export const PAYMENT_SUCCEEDED = "pwcPaymentSucceeded";
export const PAYMENT_ERRORED = "pwcPaymentErrored";
export const PAYMENT_SUCCESS_TYPE = "paymentSuccess";
export const PAYMENT_ERROR_TYPE = "paymentError";
export const BEFORE_UNLOAD = "beforeunload";
export const RESIZE = "resize";
export const CLOSED = "closed";
export const CLICK = "click";
